<template>
    <button
        class="inline-flex items-center rounded-md border border-transparent px-4 py-2 text-xs font-semibold uppercase tracking-widest text-black transition duration-150 ease-in-out hover:bg-black hover:bg-hovermintgreen focus:outline-none focus:ring-0 focus:ring-mintgreen focus:ring-offset-0 active:bg-gray-900 disabled:opacity-25">
        <slot />
    </button>
</template>
